
<div class="dropdown nav navbar-nav navbar-right customRight" *ngIf="account">
  <button class="customRightLogin" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
    {{'global.welcome' | translate}} {{account.participantName}} <span class="caret"></span>
  </button>
  <div class="dropdown-menu customLogoutArea" aria-labelledby="dropdownMenuButton">
    {{'global.lastlogin' | translate}}<br>
    {{ account.lastSuccessfulLogin}}
    <button type="button" class="btn btn-outline-primary logoutButton" (click)="logout()">{{'global.menu.account.logout' | translate}}</button>
  </div>
</div>
